import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { 
  BenefitsSection, 
  BenefitsTextContainer, 
  BenefitsContent, 
  BenefitsTitle, 
  BenefitsDescription,
  IconWrapper,
  BenefitTitle,
  BenefitDescription,MappedDiv,
  SkeletonSection,
  BenefitImage
} from '../styles/AppDetails'; 
import { useTranslation } from 'react-i18next';

const BenefitsSectionSkeleton = ({ isRtl }:any) => {
     const {
        t,
        i18n: { language },
      } = useTranslation();
  return (
    <BenefitsSection $isRtl={isRtl}>
      <BenefitsTextContainer>
        <BenefitsContent>
          <BenefitsTitle as="div">
            <Skeleton width={250} height={24} />
          </BenefitsTitle>
          <BenefitsDescription as="div">
            <Skeleton count={2} height={16} />
          </BenefitsDescription>
          
          {[1, 2, 3].map((item) => (
            <MappedDiv key={item} >
              <IconWrapper>
                <Skeleton width={30} height={30} borderRadius={5} />
              </IconWrapper>
              
              <BenefitTitle as="div">
                <Skeleton width={180} height={20} />
              </BenefitTitle>
              
              <BenefitDescription as="div">
                <Skeleton count={2} height={16} />
              </BenefitDescription>
            </MappedDiv>
          ))}
        </BenefitsContent>
      </BenefitsTextContainer>
      
      <SkeletonSection >
        <Skeleton width="100%" height="100%" borderRadius={10} />
      </SkeletonSection>
    </BenefitsSection>
  );
};

export default BenefitsSectionSkeleton;